export function getDefaultState() {
    return {
        isGray: false,
        sessionId: '',
        user: {},
        // 用户在 portal 中的业务权限
        // 目前只有 messages
        permissions: [],
        productsCanAccess: [],
        productsCanAccessHash: {},
        // 当前加载业务系统的插件权限
        pluginPermissionsHash: {},
        crtProduct: {
            code: '',
            url: '',
            deepJoin: true,
            name: '',
            initPath: '',
        },
        // 这里本想放到 state.product 里，但考虑到
        // 插件可能单独于业务系统存在，所以独立看起来要合理一些
        pluginsApiBaseUrl: '',
        isNeedSecondAuth: false,
        // 所有关于 ws 的 state 都应放在此处，不管多么复杂
        ws: {
            exportNumber: 0,
            exportList: [] // 导出消息数量
        }
    };
}

export default getDefaultState();
